type ArrowRightIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const ArrowRightIcon = (props: ArrowRightIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M9.99967 3.33301L9.05968 4.27301L12.113 7.33301H1.33301V8.66634H12.113L9.05301 11.7263L9.99967 12.6663L14.6663 7.99967L9.99967 3.33301Z"
      fill="currentColor"
    />
  </svg>
);
